import debug from 'debug';
import { cookieService } from 'Global/Shared/Components/CookieService/CookieService';

const log = debug('CookieLaw');

class CookieLaw {
	constructor(element) {
		this.element = element;

		this.cookieAcceptEvent = this.cookieAcceptHandler.bind(this);

		this.initialize();
	}

	cookieAcceptHandler(event) {
		log('cookieAcceptHandler()');
		const currentUrl = window.location.href;
		let consentText = 'empty';
		try {
			const dialogElement = document.querySelector('#CybotCookiebotDialogBodyContentText');
			if (dialogElement !== null) {
				consentText = dialogElement.innerHTML;
				consentText = consentText.trim().replace(/[\r\n]+/g, ''); // clean up the text and format it properly
				consentText = encodeURIComponent(consentText); // we need to encode the text so it doesn't conflict with the cookie
			}
		}
		catch(error) {
			log('CookieAcceptHandler() - error', error);
		}

		// Set cookie
		cookieService.Set({
			name: this.settings.cookieTempConsentName, 
			value: consentText + '&Url=' + currentUrl,
			type: 0
		});
	}

	eventListeners() {
		window.addEventListener('CookiebotOnAccept', this.cookieAcceptEvent, false);
		window.addEventListener('CookiebotOnDecline', this.cookieAcceptEvent, false);
	}

	/**
	 * @returns {Object} settings [catalogId, customerId]
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	initialize() {
		log('--- step A');
		if (this.getSettings() === null) return;

		this.eventListeners();
	}
}

export default CookieLaw;
